export function logout(){
  return {
    type: 'LOGOUT',
  }
}